import React,{useState} from "react";
import BackGroundImage from './images/3706.jpg';
import NavBar from "./Components/NavBar";
import Home from "./Components/Home";
import About from "./Components/About";
import Projects from './Components/Projects';
import Skills from './Components/Skills';
import ContactPage from "./Components/ContactPage";



function App() {
  const [activeSection, setActiveSection] = useState("home");

  return (
    <div
      className="min-h-screen flex justify-center items-center border-10 border-solid border-gray-500"
      style={{
        backgroundImage: `url(${BackGroundImage})`,
        backgroundSize: 'cover',
      }}
    >
      <NavBar setActiveSection={setActiveSection} />
      {activeSection === "home" && <Home setActiveSection={setActiveSection} />}
      {activeSection === "about" && <About setActiveSection={setActiveSection}/>}
      {activeSection === "projects" && <Projects setActiveSection={setActiveSection}/>}
      {activeSection === "skills" && <Skills setActiveSection={setActiveSection}/>}
      {activeSection === "contact" && <ContactPage setActiveSection={setActiveSection}/>}
    </div>
  );
}

export default App;

